import { WorkflowType } from '../workflow/workflowType';

export enum AnswerType {
  Text = 1,
  Emoji = 2,
  Task = 3,
  Score10 = 4,
  YesNo = 5,
  MultilineText = 10,
  MultiChoice = 11,
  Email = 12,
  Name = 13,
  PhoneNumber = 14,
  Skip = 15,
}

export const isSkipAnswer = (workflowType: WorkflowType) => {
  const answerType = workflowTypeToAnswerType(workflowType);
  return answerType === AnswerType.Skip;
};

export const workflowTypeToAnswerType = (workflowType: WorkflowType) => {
  switch (workflowType) {
    case WorkflowType.QuestionAnswerText:
      return AnswerType.Text;
    case WorkflowType.QuestionAnswerEmoji:
      return AnswerType.Emoji;
    case WorkflowType.Task:
      return AnswerType.Task;
    case WorkflowType.QuestionAnswer10Score:
      return AnswerType.Score10;
    case WorkflowType.QuestionAnswerYesNo:
      return AnswerType.YesNo;
    case WorkflowType.QuestionAnswerMultilineText:
      return AnswerType.MultilineText;
    case WorkflowType.QuestionAnswerMultipleChoice:
      return AnswerType.Text;
    case WorkflowType.QuestionAnswerCheckboxes:
      return AnswerType.MultiChoice;
    case WorkflowType.QuestionAnswerDropDown:
      return AnswerType.Text;
    case WorkflowType.QuestionAnswerEmail:
      return AnswerType.Email;
    case WorkflowType.QuestionAnswerName:
      return AnswerType.Name;
    case WorkflowType.QuestionAnswerPhoneNumber:
      return AnswerType.PhoneNumber;
    case WorkflowType.QuestionAnswerHostInsertText:
      return AnswerType.Skip;
    default:
      break;
  }
};
